import { browser } from '$app/environment';
import { firestoreDb } from '$lib/firebase';
import { cartDocumentId } from '$stores/cart';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { logError } from '$lib/helpers/errors';

/**
 * Creates a cart document and returns its ID.
 *
 * @param {string} uid          Firebase UID (use "guest" if anonymous)
 * @param {object} data         Cart payload (contents, theCart, …)
 * @returns {Promise<string|null>}
 */
export async function addCart(uid, data) {
  if (!browser) return null;                // run only on the client
  if (!uid) uid = 'guest';

  try {
    const db = firestoreDb();
    if (!db) throw new Error('Firestore not initialised');

    const docRef = await addDoc(collection(db, 'cart'), {
      ...data,
      customerID : uid,
      time       : Timestamp.now().toDate().toLocaleTimeString('en-GB'),
      date       : Timestamp.now().toDate().toLocaleDateString('en-GB'),
      createdAt  : Timestamp.now(),
      emailSent  : false
    });

    cartDocumentId.set(docRef.id);
    console.log('cart added, new ID:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('addCart error:', error);
    logError(error, 'addCart');
    return null;
  }
}
